import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M9.20338 6.4952C7.14338 2.0552 4.51338 0.0952215 2.27338 1.39522C0.103375 2.65522 0.713374 8.44517 4.05337 14.3452C8.05337 21.4252 15.8834 29.3552 15.8834 29.3552C15.8834 29.3552 13.2834 15.2652 9.20338 6.4952Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M4.89333 13.3752C4.89333 13.3752 2.36332 7.78521 3.45332 5.86521C4.53332 3.94521 7.96331 7.03524 10.4733 17.3952"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M4.89317 13.3751C3.97317 11.6951 3.17317 9.93511 2.84317 7.97511C2.77317 7.47511 2.71317 6.97519 2.81317 6.42519C2.90317 5.91519 3.09317 5.22519 3.84317 4.92519C4.21317 4.80519 4.56316 4.8651 4.86316 4.9651C5.14316 5.0851 5.39317 5.22517 5.59317 5.40517C6.02317 5.73517 6.35316 6.12516 6.66316 6.52516C7.84316 8.14516 8.58316 9.95516 9.19316 11.7752C9.79316 13.6052 10.1932 15.4851 10.4632 17.3851C9.81317 15.5851 9.17317 13.7952 8.45317 12.0452C7.72317 10.3152 6.94316 8.57514 5.86316 7.12514C5.59316 6.76514 5.30317 6.42518 4.98317 6.16518C4.67317 5.87518 4.30317 5.7552 4.13317 5.8152C3.93317 5.8352 3.72317 6.1951 3.65317 6.5851C3.56317 6.9751 3.57317 7.43515 3.59317 7.88515C3.79317 9.70515 4.32317 11.5551 4.89317 13.3751Z"
        fill={outline}
      />
      <path
        d="M74.9134 6.4952C76.9734 2.0552 79.6034 0.0952215 81.8434 1.39522C84.0134 2.65522 83.4034 8.44517 80.0634 14.3452C76.0634 21.4252 68.2334 29.3552 68.2334 29.3552C68.2334 29.3552 70.8334 15.2652 74.9134 6.4952Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M79.2235 13.3752C79.2235 13.3752 81.7535 7.78521 80.6635 5.86521C79.5835 3.94521 76.1536 7.03524 73.6436 17.3952"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M79.2233 13.3751C79.7933 11.5551 80.3233 9.70515 80.5033 7.88515C80.5233 7.43515 80.5333 6.9751 80.4433 6.5851C80.3733 6.1951 80.1633 5.8452 79.9633 5.8152C79.7933 5.7652 79.4233 5.88518 79.1133 6.16518C78.7933 6.41518 78.5033 6.76514 78.2333 7.12514C77.1533 8.57514 76.3733 10.3152 75.6433 12.0452C74.9333 13.7952 74.2933 15.5751 73.6333 17.3851C73.9033 15.4951 74.3033 13.6052 74.9033 11.7752C75.5033 9.94516 76.2533 8.14516 77.4333 6.52516C77.7433 6.12516 78.0733 5.73517 78.5033 5.40517C78.7033 5.22517 78.9633 5.0851 79.2333 4.9651C79.5333 4.8651 79.8833 4.80519 80.2533 4.92519C81.0033 5.22519 81.1933 5.91519 81.2833 6.42519C81.3833 6.97519 81.3233 7.47511 81.2533 7.97511C80.9333 9.93511 80.1433 11.6951 79.2233 13.3751Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.48192 5.47998) rotate(151.86) scale(5.55136 11.8254)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(75.8456 5.14378) rotate(28.1403) scale(5.55136 11.8254)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
